import { render } from "./AssetMetadataFields.vue?vue&type=template&id=35aa2d34"
import script from "./AssetMetadataFields.vue?vue&type=script&lang=js"
export * from "./AssetMetadataFields.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/asset/resources/vue/assets/AssetMetadataFields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35aa2d34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35aa2d34', __exports__)) {
    console.log('reload')
    api.reload('35aa2d34', __exports__)
  }
  
  module.hot.accept("./AssetMetadataFields.vue?vue&type=template&id=35aa2d34", () => {
    console.log('re-render')
    api.rerender('35aa2d34', render)
  })

}


export default __exports__